export enum ParameterType {
    Delta,
    Gamma,
    Vega,
    Theta,
    Rho,
}